<template>
    <div>
        <section-info></section-info>
        <section-form-contenu>
            <section-periode-fiscale :dossier="dossier"></section-periode-fiscale>
            <section-donnees-perso :dossier="dossier" :submitted="submitted"></section-donnees-perso>
            <section-adresse :dossier="dossier" :submitted="submitted"></section-adresse>
            <section-questions :dossier="dossier" :submitted="submitted" :listeReference="listeReference"></section-questions>
            <section-marie :dossier="dossier" :submitted="submitted" v-if="dossier.isMarie" :listeReference="listeReference"></section-marie>
            <section-non-marie :dossier="dossier" :submitted="submitted" v-if="(dossier.hasEnfants && !dossier.isMarie)" :listeReference="listeReference"></section-non-marie>
            <section-remarques :dossier="dossier"></section-remarques>
            <section-info-bareme-ajuste></section-info-bareme-ajuste>
            <button type="button" name="next" class="btn btn-primary submitandwait" @click="onSubmit">
                {{$t('Bareme.etape1.buttons.determinerBareme')}}
            </button>
        </section-form-contenu>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import TooltipUtils from '@/utils/TooltipUtils';
import BaremeApi from '@/services/BaremeRestApi';
import ContribuableIsDto from '@/models/bareme/ContribuableIsDto';
import ProgressBarUtils from '@/utils/ProgressBarUtils';
import SectionDonneesPerso from '../sections/SectionDonneesPerso.vue';
import SectionAdresse from '../sections/SectionAdresse.vue';
import SectionInfo from '../sections/SectionInfo.vue';
import SectionQuestions from '../sections/SectionQuestions.vue';
import SectionFormContenu from '../sections/SectionFormContenu.vue';
import SectionMarie from '../sections/SectionMarie.vue';
import SectionNonMarie from '../sections/SectionNonMarie.vue';
import SectionRemarques from '../sections/SectionRemarques.vue';
import SectionPeriodeFiscale from '../sections/SectionPeriodeFiscale.vue';
import SectionInfoBaremeAjuste from '../sections/SectionInfoBaremeAjuste.vue';

export default {
  name: 'bareme-etape-1',
  components: {
    SectionInfoBaremeAjuste,
    SectionPeriodeFiscale,
    SectionRemarques,
    SectionQuestions,
    SectionInfo,
    SectionFormContenu,
    SectionDonneesPerso,
    SectionAdresse,
    SectionMarie,
    SectionNonMarie,
  },
  mixins: [TooltipUtils, ProgressBarUtils],
  computed: {
    dossier() {
      return this.$store.getters['dossier/getDossier'];
    },
  },
  data() {
    return {
      submitted: false,
      listeReference: {
        typeResident: [
          {
            value: 'Frontalier',
            description: this.$t('Bareme.etape2.listeReference.typeResident.frontalier'),
            tooltip: this.getTooltip('Bareme.tooltip.titre.typeResident', 'Bareme.tooltip.contenu.typeResident.frontalier'),
          },
          {
            value: 'G',
            description: this.$t('Bareme.etape2.listeReference.typeResident.cantonGE'),
            tooltip: this.getTooltip('Bareme.tooltip.titre.typeResident', 'Bareme.tooltip.contenu.typeResident.cantonGE'),
          },
          {
            value: 'S',
            description: this.$t('Bareme.etape2.listeReference.typeResident.suisseHorsGE'),
            tooltip: this.getTooltip('Bareme.tooltip.titre.typeResident', 'Bareme.tooltip.contenu.typeResident.enSuisse'),
          }],
        typeBoolean: [
          { value: '0', description: this.$t('general.non') },
          { value: '1', description: this.$t('general.non') },
        ],
        etatCivil: [
          { value: 1, code: 'Celibataire', description: this.$t('Bareme.etape2.listeReference.etatCivil.celibataire') },
          { value: 2, code: 'Marie', description: this.$t('Bareme.etape2.listeReference.etatCivil.marie') },
          { value: 3, code: 'Divorce', description: this.$t('Bareme.etape2.listeReference.etatCivil.divorce') },
          { value: 4, code: 'Separe', description: this.$t('Bareme.etape2.listeReference.etatCivil.separe') },
          { value: 5, code: 'Veuf', description: this.$t('Bareme.etape2.listeReference.etatCivil.veuf') },
        ],
        bareme: [
          { value: '0', description: this.$t('Bareme.etape2.listeReference.bareme.baremeB') },
          { value: '1', description: this.$t('Bareme.etape2.listeReference.bareme.baremeC') },
        ],
        sourceRevenu: [
          {
            value: 1, code: 'Geneve', description: this.$t('Bareme.etape2.listeReference.sourceRevenu.aGeneve'), label: this.$t('Bareme.etape2.champs.aGeneve'),
          },
          {
            value: 2, code: 'Suisse', description: this.$t('Bareme.etape2.listeReference.sourceRevenu.enSuisse'), label: this.$t('Bareme.etape2.champs.enSuisse'),
          },
          {
            value: 3, code: 'Etranger', description: this.$t('Bareme.etape2.listeReference.sourceRevenu.etranger'), label: this.$t('Bareme.etape2.champs.etranger'),
          },
        ],
        cantons: [
          {
            label: 'Argovie',
            code: 'AG',
          },
          {
            label: 'Appenzell Rhodes-Intérieures',
            code: 'AI',
          },
          {
            label: 'Appenzell Rhodes-Extérieures',
            code: 'AR',
          },
          {
            label: 'Berne',
            code: 'BE',
          },
          {
            label: 'Bâle-Campagne',
            code: 'BL',
          },
          {
            label: 'Bâle-Ville',
            code: 'BS',
          },
          {
            label: 'Fribourg',
            code: 'FR',
          },
          {
            label: 'Glaris',
            code: 'GL',
          },
          {
            label: 'Grisons',
            code: 'GR',
          },
          {
            label: 'Jura',
            code: 'JU',
          },
          {
            label: 'Lucerne',
            code: 'LU',
          },
          {
            label: 'Neuchâtel',
            code: 'NE',
          },
          {
            label: 'Nidwald',
            code: 'NW',
          },
          {
            label: 'Obwald',
            code: 'OW',
          },
          {
            label: 'Saint-Gall',
            code: 'SG',
          },
          {
            label: 'Schaffhouse',
            code: 'SH',
          },
          {
            label: 'Soleure',
            code: 'SO',
          },
          {
            label: 'Schwytz',
            code: 'SZ',
          },
          {
            label: 'Thurgovie',
            code: 'TG',
          },
          {
            label: 'Tessin',
            code: 'TI',
          },
          {
            label: 'Uri',
            code: 'UR',
          },
          {
            label: 'Vaud',
            code: 'VD',
          },
          {
            label: 'Valais',
            code: 'VS',
          },
          {
            label: 'Zoug',
            code: 'ZG',
          },
          {
            label: 'Zurich',
            code: 'ZH',
          },
        ],
      },
    };
  },
  provide() {
    return {
      $validator: this.$validator,
    };
  },
  methods: {
    ...mapActions(['setEtapes', 'setEtapeBar', 'setUrlEnSavoirPlus']),
    async onSubmit() {
      this.submitted = true;
      // const promiseArr = this.$children.map(child => child.$validator.validateAll());

      const isValide = await this.validerForm();
      if (isValide) {
        this.dossier.bareme = await this.determinerBareme();
        if (this.dossier.etatCivil.value !== 2) {
          if (this.dossier.hasEnfants && !this.dossier.isUnionLibre && this.dossier.isGardeAlternee) {
            this.dossier.isMessageBaremeH = true;
          }
          if (this.dossier.hasEnfants && this.dossier.isUnionLibre && (this.dossier.isGardeAlternee || this.nbEnfants === 0)) {
            this.dossier.isMessageBaremeH = true;
          }
        } else {
          this.dossier.isMessageBaremeH = false;
        }
        this.dossier.isBaremeAjuste = false;
        if (this.dossier.bareme.startsWith('C')) { // && this.dossier.datesNaissanceEnfants.length < 5 && this.dossier.typeResident.value !== 'S') {
          this.dossier.isBaremeAjuste = true;
        }
        this.$router.push({ name: 'routePrelevementEtape2' });
      } else {
        // Scroll vers le prémier erreur du formulaire
        this.$el.querySelector(`[name=${this.$validator.errors.items[0].field}]`).closest('.form-group').scrollIntoView();
      }
    },
    async validerForm() {
      const promiseArr = this.$children.map(child => child.$validator.validateAll());
      return Promise.all(promiseArr.map(validation => validation.then(v => v)))
        .then(resultatValidation => !resultatValidation.includes(false))
        .catch(() => {
        // this.show_message_error_validation();
        });
    },
    async determinerBareme() {
      // Appel back-end ici
      const contribuableIsDto = new ContribuableIsDto();
      contribuableIsDto.frontalier = this.dossier.typeResident.value;
      contribuableIsDto.etatCivil = this.dossier.etatCivil.code;
      contribuableIsDto.enfantaCharge = this.dossier.hasEnfants;
      contribuableIsDto.conjointRevenu = this.dossier.hasConjointRevenu;
      if (this.dossier.isConjointFonctionnaireInt) {
        contribuableIsDto.conjointFonctionnaireInternationale = this.dossier.isConjointFonctionnaireInt;
      }
      if (this.dossier.typeFonctInt) {
        contribuableIsDto.typeFonctionnaireInternational = this.dossier.typeFonctInt.value;
      }
      contribuableIsDto.isEnUnionLibre = this.dossier.isUnionLibre;
      contribuableIsDto.gardeAlternee = this.dossier.isGardeAlternee;
      if (this.dossier.hasEnfants) {
        contribuableIsDto.dateNaissanceEnfants = this.dossier.datesNaissanceEnfants.map(k => k.dateNaissance);
      }
      contribuableIsDto.nbEnfantBaremeH = this.dossier.nbEnfants;
      contribuableIsDto.canton = this.dossier.canton ? this.dossier.canton.label : null;
      contribuableIsDto.dateChangementEtatCivil = this.dossier.dateChangementEtatCivil;
      contribuableIsDto.tauxGlobalActivite = this.dossier.tauxGlobalActivite;

      const reponseBackend = await new BaremeApi().determinerBareme(contribuableIsDto);
      return reponseBackend;
    },
    validerAVS() {
      let isValide = true;
      const noAVS = this.dossier.numeroAVS.replace(/\./g, '');
      if (noAVS.length !== 13) {
        isValide = false;
      } else {
        const sum1 = Number(noAVS.charAt(0))
                    + Number(noAVS.charAt(2))
                    + Number(noAVS.charAt(4))
                    + Number(noAVS.charAt(6))
                    + Number(noAVS.charAt(8))
                    + Number(noAVS.charAt(10));
        const sum2 = Number(noAVS.charAt(1))
                    + Number(noAVS.charAt(3))
                    + Number(noAVS.charAt(5))
                    + Number(noAVS.charAt(7))
                    + Number(noAVS.charAt(9))
                    + Number(noAVS.charAt(11));
        const sum = sum1 + 3 * sum2;
        const reste = 10 * Math.ceil(sum / 10) - sum;
        if (reste !== Number(noAVS.charAt(12))) {
          isValide = false;
        }
      }
      return isValide;
    },
    getAge(dateString, periodeFiscal) {
      const dateNaissance = moment(dateString, 'YYYY-MM-DD');

      // Règle pour l'année 2020
      if (Number(periodeFiscal) === 2020) {
        // En 2020 l'enfant doit être mineur au 31.12.2020
        return moment({ year: periodeFiscal, month: 11, day: 31 }).diff(dateNaissance, 'years');
      }

      // Règle à partir de 2021
      const dateDuJour = moment();
      // Positioner la date au dernier jour du mois qui précède
      let dernierJourDuMois = moment(dateDuJour).subtract(1, 'months').endOf('month');
      if (dateDuJour.year() < periodeFiscal) {
        // Si l'on est pas encore dans l'année de la période fiscale, on positionne la date au 31 décembre de la période fiscal - 1
        dernierJourDuMois = moment({ year: periodeFiscal }).subtract(1, 'years').endOf('year');
      }
      const age = moment(dernierJourDuMois).diff(dateNaissance, 'years');
      return age;
    },
    getMessageErreur() {
      return 'L’enfant doit avoir moins de 25 ans le dernier jour du mois précédent';
    },
  },

  created() {
    this.$validator.extend('ruleNbEnfants', {
      getMessage: () => 'Nombre d\'enfants à charge issus d\'une union précédente ne peut être supérieur au nombre d\'enfants à charge',
      validate: () => new Promise((resolve) => {
        let isValide = true;
        if (!this.dossier.isMarie && this.dossier.hasEnfants && this.dossier.nbEnfants !== 0) {
          if (this.dossier.nbEnfants > this.dossier.datesNaissanceEnfants.length) {
            isValide = false;
          }
        }
        resolve({
          valid: isValide,
        });
      }),
    });
    this.$validator.extend('validerNoAVS', {
      getMessage: () => 'Le No AVS 13 n\'est pas valide',
      validate: () => new Promise((resolve) => {
        resolve({ valid: this.validerAVS() });
      }),
    });
    this.$validator.extend('agexMax25ALaFinDuMois', {
      getMessage: () => this.getMessageErreur(),
      validate: value => new Promise((resolve) => {
        let isValide = true;
        const dateNaissance = this.getAge(value, this.dossier.periodeFiscale);
        if (dateNaissance >= 25) {
          isValide = false;
        }
        resolve({
          valid: isValide,
        });
      }),
    });
    this.$validator.extend('ruleDateChangementEtatCivil', {
      getMessage: () => 'La date est postérieure à la date du jour ou antérieure à plus de 100 ans',
      validate: value => new Promise((resolve) => {
        let isValide = true;
        const compareDate = moment(value, 'YYYY-MM-DD');
        const endDate = moment(); // aujourd'hui
        const startDate = moment().subtract(100, 'years'); // aujourd'hui - 100

        isValide = compareDate.isBetween(startDate, endDate, 'days', '[]'); // all exclusive
        resolve({
          valid: isValide,
        });
      }),
    });
    this.initProgressBar(2, [this.$t('Bareme.progressBar.etape1'), this.$t('Bareme.progressBar.etape2')], 1, this.$t('Bareme.titre'));
    this.setUrlEnSavoirPlus('https://www.ge.ch/impot-source/declaration-prelevement-impot-source');
  },
};
</script>

<style>

    ul.nav > li.active > a{
        border-bottom: 1px solid #fff;
    }
</style>
